import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './NotificationsScreen.css';

function NotificationsScreen() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;

    async function loadNotifications() {
      try {
        setLoading(true);
        setError('');
        const res = await axios.get('/api/notifications');
        if (!mounted) return;
        setNotifications(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        if (!mounted) return;
        setError('Could not load notifications.');
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }

    loadNotifications();

    return () => {
      mounted = false;
    };
  }, []);

  const openNotification = async (notification) => {
    if (!notification.read) {
      setNotifications((items) =>
        items.map((item) =>
          item.id === notification.id ? { ...item, read: true } : item,
        ),
      );
      axios.patch(`/api/notifications/${notification.id}/read`).catch(() => {});
    }

    if (notification.actionUrl) {
      window.location.assign(notification.actionUrl);
    }
  };

  if (loading) {
    return <div className="notifications-page">Loading notifications...</div>;
  }

  return (
    <div className="notifications-page">
      <div className="notifications-header">
        <h1>Notifications</h1>
      </div>

      {error && <div className="notifications-error">{error}</div>}

      {!error && notifications.length === 0 && (
        <div className="notifications-empty">
          No notifications yet.
        </div>
      )}

      {notifications.length > 0 && (
        <div className="notifications-list">
          {notifications.map((notification) => (
            <button
              key={notification.id}
              type="button"
              className={`notification-row ${notification.read ? '' : 'is-unread'}`}
              onClick={() => openNotification(notification)}
            >
              <div>
                <div className="notification-title">{notification.title}</div>
                <div className="notification-message">{notification.message}</div>
                <div className="notification-date">
                  {formatDate(notification.createdAt)}
                </div>
              </div>
              {!notification.read && <span className="notification-dot" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function formatDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export default NotificationsScreen;
